import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {LinkCard} from 'shells/card/link-card';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import {appHistory} from '../../../../history';

import styles from './add-new-popover.module.css';

const CREATOR_HASH_PREFIX = '#/create/';

type Props = {
    icon: React.ComponentType<any>;
    iconColor: string;
    title: string;
    description: string;
    to: string;
    isModalLink: boolean;
    onClick: () => void;
};

export function AddNewCard(props: Props) {
    const Icon = props.icon;

    return (
        <LinkCard
            // @ts-expect-error
            as={RoutedLink}
            to={
                props.isModalLink
                    ? {
                          ...appHistory.location,
                          hash: `${CREATOR_HASH_PREFIX}${props.to}`,
                          state: {modal: true},
                      }
                    : props.to
            }
            preventUnderline={true}
            replace={true}
            onClick={props.onClick}
        >
            <div className={styles['add-new-card']}>
                <StackLegacy isHorizontal={true} spacing={8}>
                    <Icon size={32} color={props.iconColor} />
                    <StackLegacy spacing={4}>
                        <Body color='dark' isBold={true}>
                            {props.title}
                        </Body>
                        <Body color='light' size='small'>
                            {props.description}
                        </Body>
                    </StackLegacy>
                </StackLegacy>
            </div>
        </LinkCard>
    );
}
